import { useSelect } from 'admin';
import { AutocompleteField } from 'form';
export const GradeSelector = () => {
  const {
    options: grades,
    query: { isFetching },
  } = useSelect({
    dataProviderName: 'grades',
    errorNotification: () => {
      return {
        description: 'Failed to load grades',
        message: 'Error',
        type: 'error',
      };
    },
    optionLabel: 'full_name',
    optionValue: 'id',
    pagination: { pageSize: 100000 },
    resource: '/v1/',
  });

  return (
    <AutocompleteField
      name="grade"
      disablePortal={false}
      label="Grade"
      options={grades}
      loading={isFetching}
      disabled={grades?.length === 0}
      getOptionLabel={(option) => String(option.label)}
    />
  );
};
